// PKCE (RFC 7636) for the SSO code flow. The portal is a public client, so
// without it an intercepted authorization code is enough to get tokens. The
// verifier is kept in sessionStorage across the round trip to the IdP.
const VERIFIER_KEY = 'homepal.pkce_verifier'

const base64Url = (buffer) =>
  btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')

/**
 * Adds a fresh S256 code challenge to a Cognito authorize URL. If the
 * browser can't store the verifier, the URL is returned unchanged so sign-in
 * still works without PKCE.
 */
export const withPkce = async (authorizeUrl) => {
  try {
    const verifier = base64Url(crypto.getRandomValues(new Uint8Array(32)))
    const challenge = base64Url(
      await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
    )

    sessionStorage.setItem(VERIFIER_KEY, verifier)

    return `${authorizeUrl}&code_challenge=${challenge}&code_challenge_method=S256`
  } catch (e) {
    return authorizeUrl
  }
}

/**
 * Returns the verifier for the code being exchanged, once.
 */
export const takePkceVerifier = () => {
  try {
    const verifier = sessionStorage.getItem(VERIFIER_KEY)

    sessionStorage.removeItem(VERIFIER_KEY)

    return verifier
  } catch (e) {
    return null
  }
}
